export type PathSegment = { kind: "object-key"; value: string } | { kind: "array-index"; value: number };

export type PathSegments = PathSegment[];
export type ObjectRecord = Record<string, unknown>;

// Checks that a value is an object record (not null and not an array).
export function isObjectRecord(value: unknown): value is ObjectRecord {
  return !!value && typeof value === "object" && !Array.isArray(value);
}

// Creates a path segment for an object property key.
export function toObjectKeyPathSegment(key: string): PathSegment {
  return {
    kind: "object-key",
    value: key
  };
}

// Creates a path segment for an array item index.
export function toArrayIndexPathSegment(index: number): PathSegment {
  return {
    kind: "array-index",
    value: index
  };
}
